import { Component, Input, Output, EventEmitter, Renderer2, ElementRef, HostBinding } from '@angular/core';

import { TdDataTableSortingOrder } from '../data-table.component';

export interface ITdDataTableSortChangeEvent {
  order: TdDataTableSortingOrder;
  name: string;
}
export class TdDataTableColumnComponent {
private _sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
/**
 * name?: string
 * Sets unique column [name] for [sortable] events.
 */
name: string = '';
/**
 * sortable?: boolean
 * Enables sorting events, sort icons and active column states.
 * Defaults to 'false'
 */
sortable: boolean = false;
/**
 * active?: boolean
 * Sets column to active state when 'true'.
 * Defaults to 'false'
 */
active: boolean = false;
/**
 * numeric?: boolean
 * Makes column follow the numeric data-table specs and sort icon.
 * Defaults to 'false'
 */
numeric: boolean = false;
/**
 * sortOrder?: ['ASC' | 'DESC'] or TdDataTableSortingOrder
 * Sets the sort order of column.
 * Defaults to 'ASC' or TdDataTableSortingOrder.Ascending
 * @param {?} order
 * @return {?}
 */
set sortOrder(order: 'ASC' | 'DESC') {
    let /** @type {?} */ sortOrder: string = order ? order.toUpperCase() : 'ASC';
    if (sortOrder !== 'DESC' && sortOrder !== 'ASC') {
      throw new Error('[sortOrder] must be empty, ASC or DESC');
    }

    this._sortOrder = sortOrder === 'ASC' ?
      TdDataTableSortingOrder.Ascending : TdDataTableSortingOrder.Descending;
  }
/**
 * sortChange?: function
 * Event emitted when the column headers are clicked. [sortable] needs to be enabled.
 * Emits an [ITdDataTableSortChangeEvent] implemented object.
 */
onSortChange: EventEmitter<ITdDataTableSortChangeEvent> =
                        new EventEmitter<ITdDataTableSortChangeEvent>();
/**
 * @return {?}
 */
get bindClickable(): boolean {
    return this.sortable;
  }
/**
 * @return {?}
 */
get bingSortable(): boolean {
    return this.sortable;
  }
/**
 * @return {?}
 */
get bindActive(): boolean {
    return this.active;
  }
/**
 * @return {?}
 */
get bindNumeric(): boolean {
    return this.numeric;
  }
/**
 * @param {?} _elementRef
 * @param {?} _renderer
 */
constructor(private _elementRef: ElementRef,
private _renderer: Renderer2) {
    this._renderer.addClass(this._elementRef.nativeElement, 'td-data-table-column');
  }
/**
 * @return {?}
 */
handleSortBy(): void {
    this.onSortChange.emit({name: this.name, order: this._sortOrder});
  }
/**
 * @return {?}
 */
isAscending(): boolean {
    return this._sortOrder === TdDataTableSortingOrder.Ascending;
  }
/**
 * @return {?}
 */
isDescending(): boolean {
    return this._sortOrder === TdDataTableSortingOrder.Descending;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  /* tslint:disable-next-line */
  selector: 'th[td-data-table-column]',
  styleUrls: ['./data-table-column.component.css' ],
  templateUrl: './data-table-column.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'name': [{ type: Input, args: ['name', ] },],
'sortable': [{ type: Input, args: ['sortable', ] },],
'active': [{ type: Input, args: ['active', ] },],
'numeric': [{ type: Input, args: ['numeric', ] },],
'sortOrder': [{ type: Input, args: ['sortOrder', ] },],
'onSortChange': [{ type: Output, args: ['sortChange', ] },],
'bindClickable': [{ type: HostBinding, args: ['class.mat-clickable', ] },],
'bingSortable': [{ type: HostBinding, args: ['class.mat-sortable', ] },],
'bindActive': [{ type: HostBinding, args: ['class.mat-active', ] },],
'bindNumeric': [{ type: HostBinding, args: ['class.mat-numeric', ] },],
};
}

function TdDataTableColumnComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdDataTableColumnComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDataTableColumnComponent.ctorParameters;
/** @type {?} */
TdDataTableColumnComponent.propDecorators;
/** @type {?} */
TdDataTableColumnComponent.prototype._sortOrder;
/**
 * name?: string
 * Sets unique column [name] for [sortable] events.
 * @type {?}
 */
TdDataTableColumnComponent.prototype.name;
/**
 * sortable?: boolean
 * Enables sorting events, sort icons and active column states.
 * Defaults to 'false'
 * @type {?}
 */
TdDataTableColumnComponent.prototype.sortable;
/**
 * active?: boolean
 * Sets column to active state when 'true'.
 * Defaults to 'false'
 * @type {?}
 */
TdDataTableColumnComponent.prototype.active;
/**
 * numeric?: boolean
 * Makes column follow the numeric data-table specs and sort icon.
 * Defaults to 'false'
 * @type {?}
 */
TdDataTableColumnComponent.prototype.numeric;
/**
 * sortChange?: function
 * Event emitted when the column headers are clicked. [sortable] needs to be enabled.
 * Emits an [ITdDataTableSortChangeEvent] implemented object.
 * @type {?}
 */
TdDataTableColumnComponent.prototype.onSortChange;
/** @type {?} */
TdDataTableColumnComponent.prototype._elementRef;
/** @type {?} */
TdDataTableColumnComponent.prototype._renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
